import React from 'react';
import ICtaCard from '../../../models/cta-card-set/ICtaCard';
import styles from './cta-card-set.module.scss';
import { ApplicationSettings } from '../../../models/settings';
import CtaCard from '../cta-card/cta-card';

interface CtaCardSetProps {
  ctaCards: ICtaCard[];
  appSettings?: ApplicationSettings;
  id?: string;
}

const CtaCardSet: React.FC<CtaCardSetProps> = ({ ctaCards, appSettings, id }) => {
  if (!ctaCards || ctaCards.length === 0) return <p>No CTA cards available</p>;

  return (
    <div
      className={`${styles['cta-card-set']} ${styles[`cta-card-set_${ctaCards.length}`]}`}
      id={id}
    >
      {ctaCards.map((ctaCard) => (
        <CtaCard
          key={ctaCard.id || ctaCard.title}
          aspectRatio={ctaCard.imageTransform}
          image={ctaCard.image}
          title={ctaCard.title}
          copyText={ctaCard.copyText}
          buttonProps={ctaCard.button}
          appSettings={appSettings}
        />
      ))}
    </div>
  );
};

export default CtaCardSet;
